import { Component, Input, OnInit, EventEmitter, Output, OnDestroy } from '@angular/core';

import { DataTablesService } from '../../../../core';
import { KPI_RAP, KPI_RAR, KPI_CUSTOMER_SHARE } from '../../../kpis';
import { ClienteAnaliseMercadoSearchClienteOrderByColumn as orderByColumn, ClienteAnaliseMercadoSearchClienteOrderBy } from '../cliente-analise-mercado-search-cliente-orderby';
import { ClienteAnaliseMercadoSearchCliente } from '../cliente-analise-mercado-search-cliente';
import { ClienteAnaliseMercadoSearchClienteTotal } from '../cliente-analise-mercado-search-cliente-total';



@Component({
    selector: 'sgt-cliente-analise-mercado-cliente-table',
    templateUrl: './cliente-analise-mercado-cliente-table.component.html',
    styleUrls: ['./cliente-analise-mercado-cliente-table.component.less']
})
export class ClienteAnaliseMercadoClienteTableComponent implements OnInit, OnDestroy {
    @Input() clientes: ClienteAnaliseMercadoSearchCliente[];
    @Input() quantidadeClientes: number;
    @Input() total: ClienteAnaliseMercadoSearchClienteTotal;

    @Input() orderBy: ClienteAnaliseMercadoSearchClienteOrderBy;
    @Output() orderByChange = new EventEmitter<ClienteAnaliseMercadoSearchClienteOrderBy>();

    /** Se o lançamento é controlado por quantidade */
    @Input() controleQuantidade: boolean;
    /** Se o lançamento é controlado por peso */
    @Input() controlePeso: boolean;
    /** Se o lançamento é controlado por valor */
    @Input() controleValor: boolean;

    /** Se deve exibir a Classificação RAP do cliente */
    @Input() isShowClassificaoRAP = false;
    /** Se deve exibir o inidicador de Customer Share */
    @Input() isShowCustomerShare = false;

    /** Evento para abrir a Análise de Mercado do cliente */
    @Output() openAnaliseMercado = new EventEmitter<ClienteAnaliseMercadoSearchCliente>();
    /** Evento para abrir o cadastro do cliente */
    @Output() openCliente = new EventEmitter<ClienteAnaliseMercadoSearchCliente>();
    /** Evento para pré-baixar o cliente */
    @Output() preBaixarCliente = new EventEmitter<ClienteAnaliseMercadoSearchCliente>();
    /** Evento para baixar o cliente */
    @Output() baixarCliente = new EventEmitter<ClienteAnaliseMercadoSearchCliente>();
    /** Evento para inserir uma compras no cliente */
    @Output() insertCentralCompra = new EventEmitter<void>();
    /** Evento para atualizar a central de compras */
    @Output() editCentralCompra = new EventEmitter<ClienteAnaliseMercadoSearchCliente>();
    /** Evento para inserir um participante em uma compras no cliente */
    @Output() insertParticipanteCentralCompra = new EventEmitter<ClienteAnaliseMercadoSearchCliente>();

    isCreatingDataTable: boolean
    idDataTable = 'clienteAnaliseMercadoClienteListTable';
    dataTableFooterColspan: number;
    private dataTable: any;

    // KPIs
    KPI_RAP = KPI_RAP;
    KPI_RAR = KPI_RAR;
    KPI_CUSTOMER_SHARE = KPI_CUSTOMER_SHARE;

    constructor(private dataTablesService: DataTablesService) { }

    ngOnInit(): void {
        this.createTable();
    }

    /** Cria a dataTable com pesquisa das análises de mercados dos clientes */
    private createTable(): Promise<void> {
        return new Promise<void>((resolve) => {
            const columns: any[] = [
                {
                    data: null,
                    className: 'col-options',
                },
                {
                    data: null,
                    className: 'col-nome-cliente',
                    serverOrderByColumn: orderByColumn.NomeCliente,
                },
                {
                    data: null,
                    className: 'col-cadastro-cliente',
                    serverOrderByColumn: orderByColumn.CadastroCliente,
                },
                {
                    data: null,
                    className: 'col-situacao-cliente',
                    serverOrderByColumn: orderByColumn.SituacaoCliente,
                },
            ];
            this.dataTableFooterColspan = 4;

            // Classificação RAP
            if (this.isShowClassificaoRAP) {
                columns.push(
                    {
                        data: null,
                        className: 'col-nome-classificacao-rap',
                        serverOrderByColumn: orderByColumn.ClassificacaoRAP,
                    }
                );
                this.dataTableFooterColspan++;
            }

            // Customer Share
            if (this.isShowCustomerShare) {
                columns.push(
                    {
                        data: null,
                        className: 'col-customer-share',
                        serverOrderByColumn: orderByColumn.ValorPretendidoPerc,
                    }
                );
            }

            // Quantidade
            if (this.controleQuantidade) {
                columns.push(
                    {
                        data: null,
                        className: 'col-quantidade col-quantidade-potencial text-right',
                        serverOrderByColumn: orderByColumn.QuantidadePotencial,
                    },
                    {
                        data: null,
                        className: 'col-quantidade col-quantidade-pretendida text-right',
                        serverOrderByColumn: orderByColumn.QuantidadePretendida,
                    },
                    {
                        data: null,
                        className: 'col-quantidade col-quantidade-realizada text-right',
                        serverOrderByColumn: orderByColumn.QuantidadeRealizada,
                    }
                );
            }

            // Peso
            if (this.controlePeso) {
                columns.push(
                    {
                        data: null,
                        className: 'col-peso col-peso-potencial text-right',
                        serverOrderByColumn: orderByColumn.PesoPotencial,
                    },
                    {
                        data: null,
                        className: 'col-peso col-peso-pretendido text-right',
                        serverOrderByColumn: orderByColumn.PesoPretendido,
                    },
                    {
                        data: null,
                        className: 'col-peso col-peso-realizado text-right',
                        serverOrderByColumn: orderByColumn.PesoRealizado,
                    }
                );
            }

            // Valor
            if (this.controleValor) {
                columns.push(
                    {
                        data: null,
                        className: 'col-valor col-valor-potencial text-right',
                        serverOrderByColumn: orderByColumn.ValorPotencial,
                    },
                    {
                        data: null,
                        className: 'col-valor col-valor-pretendido text-right',
                        serverOrderByColumn: orderByColumn.ValorPretendido,
                    },
                    {
                        data: null,
                        className: 'col-valor col-valor-realizado text-right',
                        serverOrderByColumn: orderByColumn.ValorRealizado,
                    }
                );
            }

            const columnDefs: any[] = [
                {orderable: false, targets: [0]}
            ]

            this.dataTablesService.showTable(`#${this.idDataTable}`, this.dataTable, {
                columnDefs,
                columns,
                order: this.orderBy?.tableOrderBy ?? [[1, 'asc']],
                searching: false,
                info: false,
                paging: false,
                processing: true,
            }).then(dataTable => {
                this.dataTable = dataTable;

                // Adicionando evendo de ordenação das colunas
                setTimeout(() => {
                    this.dataTable.on('order.dt', () => {
                        const tableOrderBy = this.dataTable.order();
                        const dataTableColumn = columns[tableOrderBy[0][0]];

                        const orderBy = {
                            column: dataTableColumn?.serverOrderByColumn,
                            dir: tableOrderBy[0][1],
                            tableOrderBy,
                        };
                        this.orderByChange.emit(orderBy);
                    });
                }, 1000);

                resolve();
            })
            .catch(() => {});
        });
    }

    /** Exibe/Oculta o indicador de carregando da table */
    setTabeLoading(isLoading: boolean) {
        this.dataTable?.processing( isLoading );
    }

    ngOnDestroy(): void {
        this.dataTable.off('order.dt');
        this.dataTablesService.destroyTable(this.dataTable);
    }
}
